// extracted by mini-css-extract-plugin
module.exports = {"title":"_37ILW","hc_main":"_6xSrm","section":"g6OEL","time":"_1Q_gt","top":"_2iGY3","content":"_195rL","bottom":"_30ha_","footer":"_2ZugP"};